import { useLocation } from 'react-router-dom';
import { useCallback, useState } from 'react';

const allowedQueryParams = ['returnUrl', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];

const useStytchQueryString = () => {
    const { search } = useLocation();
    const [queryParams] = useState(new URLSearchParams(search.slice(1)));

    const sanitizeQueryParams = useCallback(() => {
        const qp = new URLSearchParams();

        for (const key of queryParams.keys() ?? []) {
            if (allowedQueryParams.includes(key)) {
                qp.append(key, queryParams.get(key));
            }
        }

        return qp.size > 0 ? `?${qp}` : '';
    }, [queryParams]);

    return sanitizeQueryParams();
};

export default useStytchQueryString;
